import { Create } from "react-admin";
import { MealForm } from "./form";

export const AccomodationCreate = () => (
  <Create title="Create accomodation" redirect="list">
    <MealForm source="name" />
  </Create>
);
